import { createSlice } from '@reduxjs/toolkit'

const messagesSlice = createSlice({
  name: 'messages',
  initialState: {
    conversations: [] as any,
    conversation: null,
    conversationId: '',
    messages: [],
  },
  reducers: {
    setConversations: (state, { payload }: { payload: any }) => {
      state.conversations = payload
    },
    setConversation: (state, { payload }: { payload: any }) => {
      state.conversation = payload
    },
    setConversationId: (state, { payload }: { payload: any }) => {
      state.conversationId = payload
    },
    setMessages: (state, { payload }: { payload: any }) => {
      state.messages = payload
    },
    updateRecentMessage: (state, { payload }: { payload: any }) => {
      state.conversations = state.conversations.map((c: any) => {
        if (c.id === payload.convId) {
          return {
            ...c,
            recentMsg: { text: payload.text },
          }
        }
        return c
      })
    },
  },
})

export default messagesSlice.reducer
export const {
  setConversations,
  setConversation,
  setConversationId,
  setMessages,
  updateRecentMessage,
} = messagesSlice.actions
